export const CMR_STATUSES = Object.freeze({
  Created: 1,
  ReadySigning: 2,
  SignatureShipper: 3,
  SignatureDriver: 4,
  SignatureReceiver: 5,
  Mailing: 6,
  Closed: 7,
  Removed: 8,
  Unfinished: 9
})
